<div class="content-wrapper py-sm-7 bg-bulb-image">
  <div class="container">
    <div class="row">
      <div class="col justify-content-center">
        <h1 class="text-center">{{ "home.search.title" | translate }}</h1>
      </div>
    </div>
    <!--/.row-->
  </div>
</div>

<div class="container">
  <div class="search-box">
    <app-search></app-search>
  </div>
  <!--search box-->
</div>

<div class="content-wrapper">
  <div class="container">
    <div class="row align-items-md-center">
      <div class="col-md-6">
        @switch (lang) {
          @default {
            <p>
              Avointen oppimateriaalien kirjastossa voit löytää ja tallentaa avoimia oppimateriaaleja kaikilta
              koulutusasteilta. Palvelua ja sieltä löytyviä oppimateriaaleja voivat käyttää niin opettajat, kaiken
              ikäiset oppijat kuin kaikki oppimisesta kiinnostuneet. Oppimateriaalit ovat löydettävissä myös museoiden,
              kirjastojen ja arkistojen aineistoja kokoavasta
              <a href="https://finna.fi/" rel="noopener">Finna.fistä.</a>
              Aoe.fi-palvelun omistaja on Opetushallitus, joka kehittää palvelua yhdessä yhteistyökumppaneiden kanssa.
              Lue lisää
              <a routerLink="/lisatietoa">Lisätietoa</a>
              -sivulta ja katso ohjeet oppimateriaalien tallennukseen
              <a href="https://aoe.fi/materiaali/606/" rel="noopener">
                Avointen oppimateriaalien kirjaston käyttöoppaasta.
              </a>
            </p>
          }
          @case ('en') {
            <p>
              In the Library of Open Educational Resources, you can search for and share open educational resources
              (OER) from all levels of education. The service and its OERs are available for use by teachers, learners
              of all ages and everyone interested in learning. The OERs can also be found in
              <a href="https://finna.fi/" rel="noopener">Finna.fi,</a>
              which gathers materials from museums, libraries and archives under one roof. The aoe.fi service is owned
              by the Finnish National Agency for Education, which develops the service in collaboration with its
              partners. Visit the
              <a routerLink="/lisatietoa">Further information</a>
              page for more info and see our
              <a href="https://aoe.fi/materiaali/606/" rel="noopener">guide for uploading OERs.</a>
            </p>
          }
          @case ('sv') {
            <p>
              I Biblioteket för öppna lärresurser kan du hitta och spara öppna lärresurser från alla utbildningsstadier.
              Tjänsten och materialen är tillgängligt för alla lärare, elever i alla åldrar och alla som är intresserade
              av lärande. Du kan också hitta tjänstens lärresurser i
              <a href="https://finna.fi/" rel="noopener">Finna.fi</a>
              som har fascinerande material från arkiv, bibliotek, museer och övriga aktörer. "Aoe.fi-tjänstens ägare är
              Utbildningsstyrelsen, som utvecklar tjänsten tillsammans med sina samarbetspartner. Läs mer på sidan
              <a routerLink="/lisatietoa">Vanliga frågor</a>
              och se våra
              <a href="https://aoe.fi/materiaali/606/" rel="noopener">instruktionerna för att spara lärresurser.</a>
            </p>
          }
        }
      </div>

      <div class="col-md-6">
        <video controls width="100%" height="100%">
          <source src="https://aoe.fi/api/v1/download/aoepreview-1675337784058.mp4" type="video/mp4" />
          <track
            label="Teksitys"
            kind="subtitles"
            srclang="fi"
            src="https://aoe.fi/api/v1/download/avointenoppimateriaalienkirjasto-1675337953564.vtt" />
          <track
            label="Subtitles"
            kind="subtitles"
            srclang="en"
            src="https://aoe.fi/api/v1/download/aoevideovoiceovereng-1675337953558.vtt" />
          <track
            label="Textning"
            kind="subtitles"
            srclang="sv"
            src="https://aoe.fi/api/v1/download/aoevideovoiceoversve-1675337792388.vtt" />
          {{ "demo.educationalMaterial.preview.noVideoSupport" | translate }}
        </video>
      </div>
    </div>
    <!--/.row-->
  </div>
</div>

@if (recentMaterials?.length > 0) {
  <div class="content-wrapper bg-light">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center aoe-header-latest-materials">{{ "home.recentMaterials.title" | translate }}</h2>
        </div>
        @for (material of recentMaterials; track material; let i = $index) {
          <div class="col-md-6 col-lg-4 mb-3">
            <app-educational-material-card [educationalMaterial]="material"></app-educational-material-card>
          </div>
        }
      </div>
      <!-- .row -->
    </div>
  </div>
}
